import { isInIframe } from 'utils/proxyUtils';
import AppWrapper from './AppWrapper';
import inlineStyles from './main.css?inline';
import createShadowRoot from './utils/createRoot';
import extractCssFromViteHmr from './utils/extract-css';

// Allowed domains with proper TLDs
const ALLOWED_DOMAINS = [
  'localhost',
  'atarim.io',
  'wpfeedback.co',
  'atarimworker.dev'
];

function isAllowedDomain(hostname: string): boolean {

  // Check domains with proper subdomain handling
  return ALLOWED_DOMAINS.some(domain => {
    // Exact match
    if (hostname === domain) {
      return true;
    }

    // Subdomain match with proper boundary checking
    return hostname.endsWith('.' + domain);
  });
}

const styleUrl =
  import.meta.env.VITE_APP_ATARIM_PROXY_CSS || process.env.CEB_VITE_APP_ATARIM_PROXY_CSS;

const urlParams = new URLSearchParams(window.location.search);
const hasAtarimParam = Array.from(urlParams.entries())
  .some(([key, value]) =>
    key.toLowerCase() === 'atarimcollab' && value.toLowerCase() === 'true'
  )

// Use the secure isAllowedDomain function instead
const currentDomainIsAllowed = isAllowedDomain(window.location.hostname);

const shouldInitialize = hasAtarimParam || (isInIframe() && currentDomainIsAllowed);

const init = async () => {
  if (shouldInitialize) {
    // In development, fetch styles from dev server
    let styles = inlineStyles;

    if (styleUrl) {
      try {
        const response = await fetch(styleUrl);

        if (response.ok) {
          const cssText = await response.text();

          // The CSS from the dev server is wrapped in Vite HMR code, so we need to extract it
          const extractedCss = extractCssFromViteHmr(cssText);

          if (extractedCss) {
            styles = extractedCss;
          } else {
            console.warn('Failed to extract CSS from development response, falling back to inline styles');
          }
        } else {
          console.warn(`Failed to fetch CSS from development server (${response.status}), falling back to inline styles`);
        }
      } catch (error) {
        console.error('Error fetching CSS from development server:', error);
        console.warn('Falling back to inline styles');
      }
    }

    const root = createShadowRoot(styles);
    if (!root) {
      return;
    }

    root.render(<AppWrapper />);
  }
};

init();